import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSpareRequisitions, SpareRequisition } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './requisitionsModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SpareRequisition> useData={useSpareRequisitions} config={config} />;
};

export default List;
